import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next';

import { sendNudge } from './send-nudge.ts';
import {
	fireEligibilityChecked,
	fireExperimentError,
	getExperimentAnalytics,
} from './analytics.ts';
import { resolveCrossJoinNudges } from './resolve-cross-join-third-party-nudges.ts';
import { isFeatureVisited } from './feature-visited.ts';

export interface CrossJoinNudgesInput {
	cloudId: string;
	userId: string | null;
	createAnalyticsEvent: CreateUIAnalyticsEvent;
}

export const runCrossJoinThirdPartyNudgeExperiment = async ({
	cloudId,
	userId,
	createAnalyticsEvent,
}: CrossJoinNudgesInput) => {
	const analytics = getExperimentAnalytics(createAnalyticsEvent);

	try {
		if (!userId || (await isFeatureVisited())) {
			return;
		}

		const response = await resolveCrossJoinNudges({ userId, cloudId });
		if (response.ineligibilityReason !== null) {
			fireEligibilityChecked(analytics, response.ineligibilityReason);
		} else if (response.collaborators !== null) {
			fireEligibilityChecked(analytics, 'ELIGIBLE');
			await sendNudge({
				userId,
				cloudId,
				collaborators: response.collaborators,
				accessCapability: response.accessCapability,
				createAnalyticsEvent,
			});
		}
	} catch (error: any) {
		fireExperimentError(analytics, error);
	}
};
